module.exports = __webpack_public_path__ + "static/media/camera.299a8f67.svg";